export const MINIMUM_INCOME_RENT_MULTIPLIER = 2.5;

export const isBelowMinimumRentIncome = (
  totalMonthlyIncome: number,
  selectedUnitMonthlyRent: number
) =>
  selectedUnitMonthlyRent > 0 &&
  totalMonthlyIncome > 0 &&
  totalMonthlyIncome < selectedUnitMonthlyRent * MINIMUM_INCOME_RENT_MULTIPLIER;
